module.exports = __webpack_public_path__ + "img/b7-1.7909926.png";